let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5xB10")).then(() => parcelRequire('fpjBU'));